import { FunctionComponent } from 'react';
import * as React from 'react';
import classnames from 'classnames';

import { GetItemPropsOptions } from 'downshift';

import styles from './main.scss';

type SharedCreatableSearchProps = {
    promptGenerator: (inputValue: string) => React.ReactNode;
};

export type CreatableSearchProps = SharedCreatableSearchProps & {
    createOptionHandler: (arg0: { inputValue: string; name: string }) => void;
};

type CreatableOptionProps = SharedCreatableSearchProps & {
    borderTop: boolean;
    closeMenu: () => void;
    // Downshift is not well-typed. GetItemProps is horribly typed. Needs a fix from Downshift.
    getItemProps: (options: GetItemPropsOptions<$TSFixMe>) => Record<string, $TSFixMe>;
    // downshift props
    inputValue: string;
};

export const CreatableOption: FunctionComponent<CreatableOptionProps> = ({
    borderTop,
    closeMenu,
    getItemProps,
    inputValue,
    promptGenerator,
}) => {
    const optionClassName = classnames(styles.creatableOption, {
        [styles.borderTop]: borderTop,
    });
    const content = promptGenerator(inputValue);
    return (
        <div
            {...getItemProps({
                item: { label: inputValue, value: 'CREATABLE_OPTION_CREATED' },
                onClick: closeMenu,
            })}
            className={optionClassName}
        >
            {content}
        </div>
    );
};
